'use strict';

import type { IndFlag } from '../../Entities/Ind/IndFlag';
import { EntityCollection } from '../EntityCollection';

export class IndFlagCollection extends EntityCollection<IndFlag> {}
